

  
  // action
  import { add_user_to_bot, delete_bot_user_by_id, get_bot_users, get_BotDetails, get_DB_connections, get_tool_list, toggle_tool_status, update_Bot_title, updateBot_logo, updateBotDetails, updateBotDetails_logo } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../Success_Modal/reducer";
import { update_selected_table_success } from "../Table_Details/reducer";
import { GET_TOTAL_SELECTED_TABLES } from "../thunks";
import {
  add_user_to_bot_fail,
  add_user_to_bot_sucess,
    fetch_Bot_Details,
    fetch_Bot_Details_Failed,
    fetch_Bot_User_fail,
    fetch_Bot_User_success,
    reset_Bot_Details_Change,
    set_database_details_for_bot,
    set_tool_list,
    start_Bot_Details_loader,
    update_bot_details_fail,
    update_bot_details_success
  } from "./reduders";
  
  
  
  export const bot_details = (filterData) => async (dispatch) => {
    

    dispatch(start_Bot_Details_loader()) 
    try {
      let response;
      let tools_response;
  
        response = get_BotDetails({"search_bot_id":filterData , page:1 , per_page:1});
        const data = await response;
        dispatch(fetch_Bot_Details(data.data[0]));

        tools_response = get_tool_list({bot_id:filterData});
        const api_response = await tools_response;
        dispatch(set_tool_list(api_response))
           
        if(data.Database_ID && data.Bot_ID ){

          dispatch(GET_TOTAL_SELECTED_TABLES({database_id:data.Database_ID , bot_id:data.Bot_ID}))
        }
           
      
           dispatch(update_selected_table_success(data.data[0].structure))
     
      
    } catch (error) {
      
      dispatch(fetch_Bot_Details_Failed(error));
    }
  };



  export const update_bot_details = (filterData) => async (dispatch) => {
 
    try {
      let response;
           dispatch(start_Bot_Details_loader())   

           const data = new FormData()
           const {
            Bot_ID,
            Group_ID,
            Database_ID,
             assets_id,
             new_model,
             number_of_rows,
             BOT_Category,
             title,
             description,
             Bot_Sample_Question,
             model,
             instructions,
             bot_allow_see_source,
             bot_logo,
             temperature,
             top_p,
             SQL_Instruction,
             Query_Model,
             vector_chunk_count,
             send_sql_to_llm
           } = filterData; 
           const appendIfExists = (key, value) => {
            if (value !== undefined && value !== null && value !== '') {
              data.append(key, value);
            }
          };
          
          appendIfExists('Max_Record', number_of_rows);
          appendIfExists('bot_id', Bot_ID);
          appendIfExists('Group_ID', Group_ID);
          appendIfExists('Database_ID', Database_ID);
          appendIfExists('Assets_id', assets_id);
          appendIfExists('Model', new_model);
          appendIfExists('BOT_Category', BOT_Category);
          appendIfExists('Bot_Title', title);
          appendIfExists('Bot_Description', description);
          appendIfExists('Bot_Sample_Question', Bot_Sample_Question);
          appendIfExists('model', model);
          appendIfExists('Bot_Instructions', instructions);
          appendIfExists('Bot_Allow_See_Source', bot_allow_see_source);
          appendIfExists('Bot_Logo', bot_logo);
          appendIfExists('Query_Model', Query_Model);
          appendIfExists('vector_chunk_count', vector_chunk_count);
          appendIfExists('send_sql_to_llm',send_sql_to_llm === undefined ? null : (send_sql_to_llm ? 1 : 0))
          appendIfExists('SQL_Instruction', SQL_Instruction);

          
          // Parse float values only if they exist
          if (temperature !== undefined && temperature !== null) {
            data.append('temperature', parseFloat(temperature));
          }
          if (top_p !== undefined && top_p !== null) {
            data.append('top_p', parseFloat(top_p));
          }
           


           
           
          //  assets_id:_Assets_ID,
          //  new_model:_Model,
          //  number_of_rows:_Max_Record, 
          //  BOT_Category:_BOT_Category,
          //   title:_Bot_Title,
          //   description:_Bot_Description,
          //   Bot_Sample_Question:_Bot_Sample_Question,
          //   model:_Model,
          //   instructions:_Bot_Instructions,
          //   bot_allow_see_source:0 ,
          //   bot_logo:_profile_image_file 
  
        response = updateBotDetails_logo(data);
         await response;
         dispatch(bot_details(filterData.Bot_ID))

      //  bot_details(filterData.Bot_ID)
  
  
      
  
          dispatch(update_bot_details_success());
          dispatch(open_success_modal(" Bot Updated Successfully!") )
      
    } catch (error) {
      
      dispatch(update_bot_details_fail(error));
    }
  };


  export const Get_Bot_User_List = (filterData) => async (dispatch) => {
    try {
      let response;
           dispatch(start_Bot_Details_loader())      
  
        response = get_bot_users(filterData);
        const api_response = await response;
  
  
      
  
        dispatch(fetch_Bot_User_success(api_response));
      
    } catch (error) {
      
      dispatch(fetch_Bot_User_fail(error));
    }
  }

  export const Update_Bot_User_Role = (filterData) => async (dispatch) => {
    try {
      let response;
           dispatch(start_Bot_Details_loader())      
  
        response = add_user_to_bot(filterData);
        const api_response = await response;
        dispatch(Get_Bot_User_List({ bot_id: filterData.Bot_ID }))
  
        
        dispatch(open_success_modal("Updated Bot User Role"))
      
  
       
      
    } catch (error) {
    
      dispatch(fetch_Bot_User_fail(error));
    }
  }

  export const Add_Bot_User = (filterData)=> async (dispatch)=>{
    try {
      let response;
        dispatch(start_Bot_Details_loader())
      
   
        response = add_user_to_bot(filterData);
      
      
        var api_response = await response;
  
  
        dispatch(open_success_modal('User Added in Bot Successfully'))
        
        dispatch(add_user_to_bot_sucess())
  
        dispatch(Get_Bot_User_List({ bot_id: filterData.Bot_ID }))
        dispatch(bot_details(filterData.Bot_ID))
  
        // history('/Configuration')
  
        
      
        
  
     
      
    } catch (error) {
      dispatch(add_user_to_bot_fail(error));
    }
  }


  export const Delete_Bot_User = (filterData)=> async (dispatch)=>{
    try {
      let response;
        dispatch(start_Bot_Details_loader())
      
   
        response = delete_bot_user_by_id(filterData.User_ID);
        
      
      
        var api_response = await response;
  
  
        dispatch(open_success_modal(' Bot User deleted successfully'))
        
        dispatch(add_user_to_bot_sucess())
  
        dispatch(Get_Bot_User_List({ bot_id: filterData.Bot_ID }))
  
  
        // history('/Configuration')
  
        
      
        
  
     
      
    } catch (error) {
      dispatch(add_user_to_bot_fail(error));
    }
  }


  export const Update_Bot_Title = (filterData)=> async (dispatch)=>{
    try {

      dispatch(start_Bot_Details_loader())

      const _response = update_Bot_title(filterData)
  
      await _response

      let response = get_BotDetails(filterData.Assistant_Id);
       
      await response
      dispatch(add_user_to_bot_sucess())
  
  
      dispatch(open_success_modal('Bot Tittle Updated Successfully '))
      
    } catch (error) {
      dispatch(add_user_to_bot_fail(error));
    }
   




  }


  
  export const update_bot_logo = (filterData) => async (dispatch) => {
    
    try {
      let response;
           dispatch(start_Bot_Details_loader())   

           const data = new FormData()

           const {

             bot_logo,
             bot_id
           } = filterData; 

    
           data.append('file', bot_logo)
           data.append('bot_id', bot_id)
        
           
    
           


           
           
     
  
        response = updateBot_logo(data);
         await response;
   
  
          dispatch(update_bot_details_success())
      
    } catch (error) {
      
      dispatch(update_bot_details_fail(error));
    }
  };



export const TOGGLE_TOOL_STATUS = (filterData) => async (dispatch) => {
  try {
    // 1. Toggle tool status
    await toggle_tool_status(filterData);

    // 2. Fetch updated tool list
    const api_response = await get_tool_list({ bot_id: filterData.bot_id });
    // console.log("API Response:", api_response);

    // 3. Dispatch success modal and update store
    dispatch(open_success_modal("Tool Status Updated Successfully!"));
    dispatch(set_tool_list(api_response));
  } catch (error) {
    console.error("Error updating tool status:", error);
    dispatch(update_bot_details_fail(error));
  }
};


    export const GET_DB_Connection_for_bot_config = (filterData) => async (dispatch) => {



    try {
      let response;
  
  

      
   
        response = get_DB_connections(filterData);
      
      
      var api_resposne = await response;
  
      
      dispatch(set_database_details_for_bot(api_resposne))
  
  

  
     
      
    } catch (error) {
      // dispatch(fetch_db_list_fail(error));
      console.log(error)
    }
  };



  
 
  
  
  
  